import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { isLoggedInAtom, redirectToAuthEvent } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network'
import { type Pair } from '@root/entities/pair'
import { favoriteMetasModelByNetwork } from '@root/entities/pair/atoms/reatom-favorite-metas'
import { showSnackbarAction } from '@root/shared/ui-kit'

import {
  FavoritePairAddedEvent,
  FavoritePairRemovedEvent,
} from '../model/favorite-pair-change-event'

import { toggleFavoritePairRequestAction } from './favorite-requests'
import { favoritePairsChangedEvent } from './reatom-favorite-pairs'

export const toggleFavoritePairAction = action(
  async (ctx, { pair }: { pair: Pair.PairMinimal }) => {
    const isLoggedIn = ctx.get(isLoggedInAtom)
    if (!isLoggedIn) {
      showSnackbarAction(ctx, {
        text: i18next.t('auth.log-in-to-your-account'),
        intent: 'info',
      })
      redirectToAuthEvent(ctx)

      return
    }

    const network = ctx.get(selectedNetworkAtom)

    const result = await ctx.schedule(() =>
      toggleFavoritePairRequestAction(ctx, {
        network,
        pair: pair.address,
        baseTokenAddress: pair.base.address,
        quoteTokenAddress: pair.quote.address,
      }),
    )

    if (Result.isFailure(result)) {
      showSnackbarAction(ctx, {
        text: i18next.t('trading.favorites.error'),
        intent: 'error',
      })
      return
    }

    favoriteMetasModelByNetwork[network].updateFromDtos(ctx, result.success)
    const isAdded = result.success.some((it) => it.pairAddress === pair.address)

    const FavoritePairEvent = isAdded
      ? FavoritePairAddedEvent
      : FavoritePairRemovedEvent

    favoritePairsChangedEvent(
      ctx,
      new FavoritePairEvent({
        network,
        pairAddress: pair.address,
      }),
    )

    if (isAdded) {
      showSnackbarAction(ctx, {
        text: i18next.t('trading.favorites.added', {
          ticker: pair.quote.ticker,
        }),
        intent: 'success',
      })

      return
    }
    showSnackbarAction(ctx, {
      text: i18next.t('trading.favorites.removed', {
        ticker: pair.quote.ticker,
      }),
      intent: 'success',
    })
  },
  'toggleFavoritePairAction',
)
